<cdc-footer 
    [config]="footer()" 
    [fluid]="true" 
    [sidePadding]="50">
</cdc-footer>